<template>
  <div>
    <div style="display:flex;flex-wrap:wrap; padding:10px;" class="bloc">
      <div>{{ this.nameEvent }}</div>
      <div style="margin-left:auto;">
        <button class="button is-primary" @click="handleRedirect">
          {{ $t("attendees.return") }}
        </button>
      </div>
    </div>

    <div
      class="eventifyBackground"
      :style="
        this.background !== '' && this.background !== null
          ? `background-image:url('${url_event}${this.background}'`
          : `background-image:'src\assets\img\public_background_home.png';`
      "
    >
      <br />
      <div id="tableContainer">
        <div class="is-widescreen">
          <div
            class="bloc"
            style="margin-bottom:5px;padding:10px;display:flex; flex-wrap:wrap;"
          >
            <div style="margin:5px 10px 5px 0px;">
              <button
                class="button"
                @click="
                  () => {
                    formIsActive = !formIsActive;
                    accepts_terms_conditions = false;
                  }
                "
              >
                {{ $t("attendees.selfAdding") }}
              </button>
            </div>
            <div style="margin:5px 10px 5px 0px;" class="panel_number">
              {{
                $tc("attendees.nombre_inscrit", this.backupData.length, {
                  nbAttendees: backupData.length
                })
              }}
            </div>
            <div style="margin:5px 10px 5px 0px;" class="panel_number">
              {{
                $tc("attendees.nombre_present", this.getPresentTotal, {
                  nbAttendees: this.getPresentTotal
                })
              }}
            </div>
            <div style="margin-left:auto; display:flex;">
              <input
                :placeholder="$t('attendees.searchAttendee')"
                @input="search"
                type="search"
                v-model="search_query_attendees"
              />
              <button class="button is-primary" @click="search">
                {{ $t("button.chercher") }}
              </button>
            </div>
          </div>
        </div>
        <div>
          <div style="padding:10px;" class="bloc">
            <div style="display:flex;">
              <button class="button" @click="searchLetters('')">
                {{ $t("attendees.showAll") }}
              </button>
              <div id="lettersOnly">
                <a
                  class="letters"
                  :class="letter === currentLetter ? 'activeLetter ' : ''"
                  v-for="(letter, key) in letters"
                  :key="key"
                  @click="searchLetters(letter)"
                  >{{ letter }}</a
                >
              </div>
            </div>
          </div>
        </div>
        <div>
          <b-table
            style="margin-bottom:10px;overflow-x:hidden;overflow-y:auto;height:80vh;"
            :data="data"
            :loading="isLoadingList"
            :narrowed="true"
            :hoverable="true"
            :paginated="data.length > 50 ? true : false"
            per-page="50"
            default-sort="last_name"
          >
            <template>
              <b-table-column
                v-slot="props"
                custom-key="lastName"
                field="last_name"
                sortable
                centered
                :label="$t('attendees.lastName')"
              >
                <b-input
                  v-if="props.row.editable"
                  type="text"
                  v-model="props.row.last_name"
                  :placeholder="props.row.last_name"
                >
                </b-input>
                <p v-else>
                  {{ props.row.last_name }}
                </p>
              </b-table-column>
              <b-table-column
                v-slot="props"
                custom-key="girstName"
                field="first_name"
                sortable
                centered
                :label="$t('attendees.firstName')"
              >
                <b-input
                  v-if="props.row.editable"
                  type="text"
                  v-model="props.row.first_name"
                  :placeholder="props.row.first_name"
                >
                </b-input>
                <p v-else>
                  {{ props.row.first_name }}
                </p>
              </b-table-column>
              <b-table-column
                v-slot="props"
                custom-key="email"
                :visible="shortcut_moderateur != undefined"
                field="email"
                sortable
                centered
                :label="$t('attendees.email')"
              >
                <b-input
                  v-if="props.row.editable"
                  type="text"
                  v-model="props.row.email"
                  :placeholder="props.row.email"
                >
                </b-input>
                <p v-else v-show="props.row.email !== 'null'">
                  {{ props.row.email }}
                </p>
              </b-table-column>
              <b-table-column
                v-slot="props"
                custom-key="company"
                field="company"
                sortable
                centered
                :label="$t('attendees.company')"
              >
                <p v-show="props.row.company !== 'null'">
                  {{ props.row.company }}
                </p>
              </b-table-column>

              <b-table-column
                v-slot="props"
                custom-key="present"
                sortable
                field="present"
                centered
                :label="$t('attendees.present')"
              >
                <b-switch
                  style="margin-right:-8px;"
                  size="is-small"
                  type="is-success"
                  v-model="props.row.present"
                  @change.native="sendEdit(props)"
                  native-value="present"
                  :true-value="1"
                  :false-value="0"
                >
                </b-switch>
              </b-table-column>

              <b-table-column
                v-slot="props"
                custom-key="agrees"
                sortable
                field="accepts_terms_conditions"
                centered
                :label="$t('attendees.agrees')"
              >
                <b-icon
                  pack="fas"
                  class="GNUIcons"
                  :icon="
                    props.row.accepts_terms_conditions === 1
                      ? 'check'
                      : props.row.accepts_terms_conditions === 0
                      ? 'times'
                      : 'question'
                  "
                  :type="
                    props.row.accepts_terms_conditions === 1
                      ? 'is-success'
                      : props.row.accepts_terms_conditions === 0
                      ? 'is-danger'
                      : ''
                  "
                  :style="
                    accepts_terms_conditions === 1
                      ? ''
                      : accepts_terms_conditions === 0
                      ? ''
                      : 'padding:14px'
                  "
                  @click.native="handleAcceptTC(props)"
                ></b-icon>
              </b-table-column>

              <b-table-column
                v-slot="props"
                custom-key="edit"
                :visible="shortcut_moderateur != undefined"
                field="editable"
                centered
                :label="$t('attendees.edit')"
              >
                <a @click="enableEdit(props)">
                  <b-icon pack="fas" icon="user-edit"></b-icon>
                </a>
              </b-table-column>

              <b-table-column
                v-slot="props"
                custom-key="delete"
                :visible="shortcut_moderateur != undefined"
                field="delete"
                centered
                :label="$t('attendees.delete')"
              >
                <a @click="dialogBeforeDelete(props)">
                  <b-icon pack="fas" icon="times-circle"></b-icon>
                </a>
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon pack="far" icon="frown"> </b-icon>
                  </p>
                  <p>{{ $t("attendees.none") }}.</p>
                </div>
              </section>
            </template>
          </b-table>
          <br /><br /><br />
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="editing"
      @close="
        () => {
          search_query_attendees = '';
        }
      "
      ><div id="modalEdit">
        <Edit :row="rowBeingEdited.row" :allRows="data" />
      </div>
    </b-modal>
    <b-modal :width="640" style="font-size:12px;" :active.sync="formIsActive">
      <div id="modalCreate" style="padding:20px;">
        <img
          @click="closeModal()"
          src="@/assets/img/icons/close-icon.png"
          alt="close-icon"
          class="icon-close"
        />
        <div style="text-align:center;font-size:14px;">
          {{ $t("attendees.selfAdding") }}
        </div>
        <hr />
        <div>
          <form @submit.prevent="handleSingleUpload">
            <div id="addAttendee">
              <b-field :label="$t('attendees.firstName') + '*'">
                <b-input id="firstname" v-model="firstName"></b-input>
              </b-field>
              <b-field :label="$t('attendees.lastName') + '*'">
                <b-input id="lastname" v-model="lastName"></b-input>
              </b-field>
              <b-field
                :label="$t('attendees.email') + '*'"
                :type="validEmail === false ? 'is-danger' : ''"
              >
                <b-input id="email" v-model="email" @input="validate"></b-input>
              </b-field>
              <b-field :label="$t('attendees.company')"
                ><input type="text" id="company" class="input" v-model="company"
              /></b-field>
            </div>
            <br />
            <span id="switches">
              <b-switch
                type="is-success"
                value.native="1"
                :true-value="1"
                :false-value="0"
                v-model="present"
                size="is-small"
              >
                {{ $t("attendees.present") }}
              </b-switch>
              <b-icon
                pack="fas"
                class="GNUIcons"
                :icon="
                  accepts_terms_conditions === 1
                    ? 'check'
                    : accepts_terms_conditions === 0
                    ? 'times'
                    : 'question'
                "
                :style="
                  accepts_terms_conditions === 1
                    ? ''
                    : accepts_terms_conditions === 0
                    ? ''
                    : 'padding:14px'
                "
                :type="
                  accepts_terms_conditions === 1
                    ? 'is-success'
                    : accepts_terms_conditions === 0
                    ? 'is-danger'
                    : ''
                "
                v-model="accepts_terms_conditions"
                @click.native="confirmCGUCreate()"
              ></b-icon>
              <span style="margin-left:5px;">{{ $t("attendees.agrees") }}</span>
            </span>
            <br />
            <b-field class="emailInputContainer">
              <button
                class="button is-primary is-centered emailInput"
                :disabled="checkCorrectForm"
                type="is-success"
              >
                {{ $t("attendees.add") }}
              </button>
            </b-field>
            <div style="font-size:12px;">
              {{ $t("popup.required") }}
            </div>
          </form>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Edit from "../popup/popupEditAdmin";
import Create from "../popup/popupCreateAdmin";

export default {
  name: "AttendeesPublic",
  components: {
    Edit,
    Create
  },
  data() {
    return {
      currentLetter: null,
      letters: [..."abcdefghijklmnopqrstuvwxyz"],
      isLoadingList: true,
      search_query_attendees: "",
      shortcut: this.$route.params.shortcut,
      shortcut_moderateur: this.$route.params.shortcut_moderateur,
      url_event: process.env.URL_MEDIA,
      background: "",
      liens: this.$store.state.evenement.configure_links_evenement_name,
      data: [],
      backupData: [],
      event_id: null,
      url_shortcut: process.env.URL_SHORTCUT,
      publicCode: null,
      isImageModalActive: false,
      qrCode: "",
      email: "",
      firstName: "",
      lastName: "",
      company: "",
      present: false,
      accepts_terms_conditions: null,
      formIsActive: false,
      editing: false,
      rowBeingEdited: "",
      validEmail: undefined,
      nameEvent: null,
      gnu: false,
      globalProps: ""
    };
  },
  created() {
    this.isLoadingList = true;
    this.fetchData();
    let room = "Room_Eventify_" + this.event_id;
    this.$socket.emit("room", room);
  },
  beforeDestroy() {
    let room = "Room_Eventify_" + this.event_id;
    this.$socket.emit("leave_room", room);
  },
  sockets: {
    connect: function() {
      let room = "Room_Eventify_" + this.event_id;
      this.$socket.emit("room", room);
    },
    channel: function(data) {
      let message = JSON.parse(decodeURIComponent(data));
      switch (message.type) {
        case "DELETE_ATTENDEE":
          if (Array.isArray(message.attendee)) {
            this.backupData = this.data = message.attendee;
          } else {
            this.backupData = this.data = [];
          }
          this.currentLetter = "";
          this.search_query_attendees = "";
          break;

        case "NEW_ATTENDEE":
          this.backupData.push(message.attendee);
          break;

        case "UPDATE_ATTENDEE":
          let index = this.backupData.findIndex(
            x => x.id === message.attendee.id
          );
          // this.data = this.backupData
          if (index >= 0) {
            this.backupData[
              index
            ].first_name = message.attendee.first_name.replace(/\s/g, "");
            this.backupData[
              index
            ].last_name = message.attendee.last_name.replace(/\s/g, "");
            this.backupData[
              index
            ].last_name = message.attendee.last_name.replace(/\s/g, "");
            if (message.attendee.email) {
              this.backupData[index].email =
                message.attendee.email.replace(/\s/g, "") || "";
            } else {
              this.backupData[index].email = "";
            }
            if (message.attendee.company) {
              this.backupData[index].company =
                message.attendee.company.replace(/\s/g, "") || "";
            } else {
              this.backupData[index].company = "";
            }
            this.backupData[index].present = message.attendee.present;
            this.backupData[index].accepts_terms_conditions =
              message.attendee.accepts_terms_conditions;
            this.backupData[index].id = message.attendee.id;
            this.backupData[index].event_id = message.attendee.event_id;
            this.backupData[index].editable = message.attendee.editable;
          } else {
            this.backupData.push(message.attendee);
          }
          // this.currentLetter = ''
          // this.search_query_attendees = ''
          break;

        default:
          break;
      }
    }
  },
  computed: {
    checkCorrectForm() {
      if (this.validEmail || this.email === null || this.email === "") {
        if (this.firstName !== null && this.firstName !== "") {
          if (this.lastName !== null && this.lastName !== "") {
            return false;
          }
        }
      }
      return true;
    },
    getPresentTotal: {
      get: function() {
        let total = 0;
        this.backupData.forEach(element => {
          if (element.present) {
            total++;
          }
        });
        return total;
      }
    }
  },
  methods: {
    closeModal() {
      this.formIsActive = false;
    },
    confirmCGU(props = []) {
      this.globalProps = props;

      this.$buefy.dialog.confirm({
        title: this.$i18n.t("public.titrecgu"),
        message: this.$i18n.t("public.cgudetail"),
        cancelText: this.$i18n.t("button.refuse"),
        confirmText: this.$i18n.t("public.cgu"),
        size: "is-small",
        type: "is-success",
        onConfirm: () => {
          props.row.accepts_terms_conditions = 1;
          if (
            this.globalProps !== [] &&
            this.globalProps !== null &&
            this.globalProps !== "" &&
            this.globalProps !== undefined
          ) {
            this.sendEdit(props);
          }
        },
        onCancel: e => {
          if (e === "button") {
            props.row.accepts_terms_conditions = 0;
          }
          if (
            this.globalProps !== [] &&
            this.globalProps !== null &&
            this.globalProps !== "" &&
            this.globalProps !== undefined
          ) {
            this.sendEdit(props);
          }
        }
      });

      return true;
    },
    confirmCGUCreate() {
      this.$buefy.dialog.confirm({
        title: this.$i18n.t("public.titrecgu"),
        message: this.$i18n.t("public.cgudetail"),
        cancelText: this.$i18n.t("button.refuse"),
        confirmText: this.$i18n.t("public.cgu"),
        size: "is-small",
        type: "is-success",
        onConfirm: () => {
          this.accepts_terms_conditions = 1;
        },
        onCancel: e => {
          if (e === "button") {
            this.accepts_terms_conditions = 0;
          }
        }
      });

      return true;
    },
    searchLetters(e) {
      this.search_query_attendees = "";
      if (this.currentLetter === e) {
        this.currentLetter = "";
        this.data = this.backupData;
      } else {
        this.currentLetter = e;
        let localeData = this.backupData;
        if (e !== "") {
          this.data = [];
          var regex = new RegExp("^[" + e + "][a-zA-Z0-9.,$;-ç éè]*$", "i");
          localeData.forEach(row => {
            if (regex.test(row.last_name)) {
              this.data.push(row);
            }
          });
        } else {
          this.data = this.backupData;
        }
      }
    },
    dialogBeforeDelete(props) {
      this.$buefy.dialog.confirm({
        message: this.$i18n.t("attendees.sureSingle"),
        onConfirm: () => {
          this.handleDelete(props);
        },
        type: "is-danger",
        cancelText: this.$i18n.t("attendees.cancel"),
        confirmText: this.$i18n.t("attendees.confirm")
      });
    },
    handleDelete(props) {
      let index = this.data.findIndex(x => x.id === props.row.id);

      let payload = {
        id: this.data[index].id,
        event_id: this.event_id
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .delete(`${process.env.URL_SSO_API}shortcut/attendees`, {
          data: payload
        })
        .then(res => {
          if (
            res.data !== null &&
            res.data !== undefined &&
            res.data !== [] &&
            typeof res.data !== "number"
          ) {
            res.data.forEach(attendee => {
              attendee.editable = false;
              this.backupData = this.data = res.data;
            });
          }
          this.$buefy.toast.open({
            type: "is-success",
            message: this.$i18n.t("toast.deleteSuccess")
          });
        })
        .catch(err => {
          /* this.$buefy.toast.open({
            type: "is-danger",
            message: this.$i18n.t("toast.uploadError" + err)
          }); */
        });
    },
    validate() {
      var regEmail = /^[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}(;[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}){0,20}$/;

      if (
        regEmail.test(String(this.email).toLowerCase()) ||
        this.email === ""
      ) {
        this.validEmail = true;
      } else {
        this.validEmail = false;
      }
    },
    sendEdit(props) {
      let index = this.data.findIndex(x => x.id === props.row.id);

      let data = {
        id: this.data[index].id,
        event_id: this.event_id,
        first_name: props.row.first_name,
        last_name: props.row.last_name,
        email: props.row.email,
        company: props.row.company,
        present: props.row.present,
        accepts_terms_conditions: props.row.accepts_terms_conditions
      };

      axios
        .put(`${process.env.URL_SSO_API}shortcut/attendees`, data, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          this.data[props.index].editable = false;
        })

        .catch(err => {
          /* this.$buefy.toast.open({
            type: "is-danger",
            message: this.$i18n.t("toast.uploadError" + err)
          }); */
        });
      this.firstName = "";
      this.lastName = "";
      this.email = "";
    },
    handleSingleUpload(e) {
      if (this.firstName !== "" && this.lastName !== "") {
        let data = {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          company: this.company,
          present: this.present,
          accepts_terms_conditions: this.accepts_terms_conditions,
          event_id: this.event_id
        };

        e.srcElement[0].focus();
        axios
          .post(`${process.env.URL_SSO_API}shortcut/attendees`, data, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(() => {
            this.$buefy.toast.open({
              type: "is-success",
              message: this.$i18n.t("toast.uploadSuccess")
            });
            this.formIsActive = false;
          })

          .catch(err => {
            let mail = "";
            mail = err.response.data.message.split(" ")[7];
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$parent.$i18n.t("attendees.duplicateMail")
            });
            this.formIsActive = false;
          });
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.company = "";
        this.accepts_terms_conditions = null;
        this.present = 0;
      } else {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.emptyInput")
        });
      }
    },
    fetchData() {
      this.isLoadingList = true;
      let payload = null;
      if (this.shortcut) {
        payload = `shortcut=${this.shortcut}`;
      } else {
        payload = `shortcut_moderateur=${this.shortcut_moderateur}`;
      }
      axios
        .get(`${process.env.URL_SSO_API}shortcut/attendees?${payload}`)
        .then(response => {
          this.isLoadingList = false;
          this.data = [];

          this.nameEvent = response.data[response.data.length - 1].name;
          this.event_id = response.data[response.data.length - 1].id;
          this.background = response.data[response.data.length - 1].media;
          let room = "Room_Eventify_" + this.event_id;
          this.$socket.emit("room", room);

          for (let i = 0; i < response.data.length - 1; i++) {
            this.data.push({
              first_name: response.data[i].first_name,
              last_name: response.data[i].last_name,
              email: response.data[i].email,
              company: response.data[i].company,
              present: response.data[i].present,
              accepts_terms_conditions:
                response.data[i].accepts_terms_conditions,
              id: response.data[i].id,
              event_id: response.data[i].event_id,
              editable: false
            });
          }
          this.backupData = this.data;
          this.isLoadingList = false;
          return true;
        })
        .catch(error => {
          // window.location = process.env.URL_SSO_FRONT
          this.isLoadingList = false;
          return false;
        });
    },

    enableEdit(props) {
      this.rowBeingEdited = props;
      this.editing = true;
    },
    handleAcceptTC(props) {
      this.confirmCGU(props);
    },
    handleRedirect() {
      if (this.shortcut_moderateur) {
        this.$router.push("/moderateur/" + this.shortcut_moderateur + ".htm");
      } else {
        this.$router.push("/" + this.shortcut + ".htm");
      }
    },
    getPdfLanguage() {
      let pdf = "";
      this.$store.state.langage.langue === "fr"
        ? (pdf = "TermeEtConditions.pdf")
        : (pdf = "TermsAndConditions.pdf");
      return pdf;
    },
    search(e) {
      this.currentLetter = null;
      let localeData = this.backupData;
      if (e !== "") {
        this.data = [];
        var regex = new RegExp(
          "^" + this.search_query_attendees + "[a-zA-Z0-9.,$;@ éè]*$",
          "i"
        );
        localeData.forEach(row => {
          if (
            regex.test(row.email) ||
            regex.test(row.last_name) ||
            regex.test(row.first_name)
          ) {
            this.data.push(row);
          }
        });
      } else {
        this.data = this.backupData;
      }
    }
  }
};
</script>

<style scoped>
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}
#modalCreate {
  font-size: 12px;
  text-align: center;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin: 50px;
  background-color: white;
}
.list-buttons {
  margin: auto 0px;
}
.panel_number {
  height: auto;
  border: 0.5px solid #424a60;
  font-weight: bold;
  border-radius: 10px;
  color: #424a60;
  font-size: 12px;
  margin-right: 10px;
  padding: 5px;
}
#modalEdit {
  font-size: 12px;
  margin: 50px;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
}
#buttonPageAttendees > .button {
  margin: 10px auto;
}
#searchAddContainer {
  min-width: 50%;
  margin: 15px auto 0px;
  padding-bottom: 0px !important;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.GNUIcons {
  cursor: pointer;
  border: 0.6px solid #80808070;
  border-radius: 1px;
  padding: 1px;
  box-shadow: 0.5px 0.5px 1px #ae8080;
}

.activeLetter {
  color: black;
  font-size: 1.6em !important;
}

#buttonAll {
  font-size: 12px;
  margin: auto 0px;
  text-transform: capitalize;
  background: #424a60;
  color: white;
  padding: 0px 3px;
  border-radius: 3px;
}

.letters {
  margin: auto calc(15px - 5px);
  line-height: 20px;
  font-size: 20px;
  text-transform: uppercase;
}
#lettersOnly {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
#searchByLetters {
  background-color: white;
  padding: 0px;
  width: 100%;
  margin-bottom: -3px;
  border-radius: 5px 5px 0px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  border-bottom: 1px solid black;
}

.addAttendee {
  margin-top: 100px;
  background-color: white;
  border-radius: 15px;
}

#switches {
  margin: auto;
}

#tableContainer {
  max-width: max-content;
  margin: 0px auto 0px;
}

.emailInput {
  width: 20%;
  display: block;
  margin: 10px auto;
}

.eventifyBackground {
  width: auto;
  height: 100vh;
  background: #e6ecf0;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}

#buttonPublicQrAttendees,
#buttonPublicQrAttendees button {
  margin: 10px auto;
  left: calc(48% - 77px);
}

#buttonPublicPageAttendees,
#buttonPublicPageAttendees button {
  margin: 10px auto;
  left: calc(48% - 83px);
}

/* .noMaxWidth{
    max-width: none;
} */

/* .searchBox {

} */

.level {
  background: none;
  /* max-width: 1200px; */
  margin: 110px auto;
}

#pdfFooter {
  margin: 10px;
  text-align: center;
  font-size: 1.1em;
}
</style>



// WEBPACK FOOTER //
// src/components/attendees/AttendeesModList.vue